import { render, staticRenderFns } from "./detailStatistic.vue?vue&type=template&id=7f562c3a"
import script from "./detailStatistic.vue?vue&type=script&lang=js"
export * from "./detailStatistic.vue?vue&type=script&lang=js"
import style0 from "./detailStatistic.vue?vue&type=style&index=0&id=7f562c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports